import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',

    alignItems: 'center',
    heigth: '56px',
    marginBottom: '14px',
  },
  input: {
    marginBottom: theme.spacing(1),
    flex: 1,
    height: '75px',
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}))

export default useStyles
